import React, { useEffect } from "react";
import NavigationBar from "./navigation/NavigationBar";
import SidebarPatient from "./sidebars/SidebarPatient";
import SidebarAdmin from "./sidebars/SidebarAdmin";
import SidebarClinician from "./sidebars/SidebarClinician";
import Footer from "./Footer";
import { useAuth } from "../contexts/AuthContext";
import BasicSidebar from "./sidebars/BasicSidebar";
import { useNavigate } from "react-router";

/**This component contains the content of the impressum */
interface ImpressumProps {
  title: string;
}

const Impressum = ({ title }: ImpressumProps) => {
  const navigate = useNavigate();
  const authContext = useAuth();
  const { isAuthenticated, userInfo } = authContext.state;

  /**Checks wheter the user is logged in or not.
   * If the user is logged in, the states would be set.
   */
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = title;
  }, [title, authContext]);

  /**
   * Renders the sidebar according to usertype
   */
  const renderSidebar = () => {
    if (!isAuthenticated) {
      // Return button for unloged user
      return (
        <BasicSidebar
          sidebarItems={[
            {
              title: "Zurück",
              activeButton: false,
              onClickFunction: () => navigate(-1),
              imgSrc: (
                <span className="material-symbols-rounded">arrow_back</span>
              ),
              buttonId: "backToLogin",
              hideChevron: true,
            },
          ]}
        />
      );
    }

    switch (userInfo?.userType) {
      case "patient":
        return <SidebarPatient />;
      case "clinician":
        return <SidebarClinician />;
      case "admin":
        return <SidebarAdmin />;
      default:
        return null;
    }
  };

  return (
    <div>
      <div className={isAuthenticated ? "header-fixed" : ""} id="body">
        {isAuthenticated ? (
          <>
            {/* navigation bar (bar on the top) */}
            <NavigationBar />
          </>
        ) : null}
        <div className="container-fluid">
          <div className="row">
            {/* Sidebar (bar on the side) */}
            {renderSidebar()}

            {/* Content */}
            <div className="col container p-3 " id="main-content">
              <h3>Impressum</h3>
              <br />

              <h5>Angaben gemäß § 5 TMG</h5>
              <p>
                <em>
                  Universitätsklinikum Freiburg
                  <br />
                  Breisacher Straße 153
                  <br />
                  D 79110 Freiburg
                  <br />
                </em>
              </p>
              <br />

              <h5>
                Das Universitätsklinikum Freiburg ist eine rechtsfähige Anstalt
                des öffentlichen Rechts der Albert-Ludwigs-Universität Freiburg.
              </h5>
              <h5>Vertreten durch:</h5>
              <h5>Vorstand:</h5>
              <p>
                <em>
                  Leitender Ärtzlicher Direktor: Prof. Dr. Dr. h.c. Frederik
                  Wenz (Vorsitz)
                  <br />
                  Kaufmännische Direktorin: Anja Simon
                  <br />
                  Stellvertretender Leitender Ärztlicher Direktor: Prof. Dr. Dr.
                  Rainer Schmelzeisen
                  <br />
                  Dekan der Medizinischen Fakultät: Prof. Dr. Lutz Hein
                  <br />
                  Pflegedirektor: Helmut Schifferer
                  <br />
                </em>
              </p>

              <h5>Aufsichtsrat:</h5>
              <p>
                <em>
                  Vorsitzender: Dr. Carsten Dose
                  <br />
                  Stellvertretender Vorsitzender: Rektorin Prof. Dr. Kerstin
                  Kriegstein
                  <br />
                </em>
              </p>

              <h5>Kontakt</h5>
              <p>
                <em>
                  Telefon: +49 761 270-0
                  <br />
                  E-mail: info@uniklinik-freiburg.de
                  <br />
                </em>
              </p>

              <h5>Umsatzsteuer</h5>
              <p>
                <em>
                  Umsatzsteuer-Identifikationsnummer gemäß §27 a
                  Umsatzsteuergesetz:
                  <br />
                  DE 811506626
                  <br />
                </em>
              </p>

              <h5>Aufsichtsbehörde</h5>
              <p>
                <em>
                  Ministerium für Wissenschaft, Forschung und Kunst
                  Baden-Württemberg <br />
                  Königstraße 46 <br />
                  70173 Stuttgart
                </em>
              </p>

              <h5>Inhalt:</h5>
              <p>
                <em>
                  Die inhaltliche Verantwortung und die Verantwortung im Sinne
                  des Presserechts liegen bei der jeweiligen
                  informationseinstellenden Einrichtung:
                  <br />
                  Klinik für Psychosomatische Medizin und Psychotherapie
                  <br />
                  Sektion Systemische Gesundheitsforschung
                  <br />
                  Hauptstraße 8
                  <br />
                  79104 Freiburg
                  <br />
                  Telefon: +49 761 270-68805
                  <br />
                </em>
              </p>

              <h5>Angaben zur Berufshaftpflichtversicherung</h5>
              <p>
                <em>
                  Name und Sitz des Versicherers:Name und Sitz des Versicherers:
                  HDI Global SE, Riethorst 4, 30659 Hannover
                  <br />
                  Räumliche Geltung: Deutschland
                  <br />
                </em>
              </p>

              <h5>Haftung für Inhalte</h5>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                gespeicherte fremde Informationen zu überwachen oder nach
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                hinweisen.
              </p>
              <p>
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
                Informationen nach den allgemeinen Gesetzen bleiben hiervon
                unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
                Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden
                wir diese Inhalte umgehend entfernen.
              </p>

              <h5>Haftung für Links</h5>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
                wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
                Verlinkung nicht erkennbar. Eine permanente inhaltliche
                Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
                Bekanntwerden von Rechtsverletzungen werden wir derartige Links
                umgehend entfernen.
              </p>

              <h5>Urheberrecht</h5>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten,
                nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
                dieser Seite nicht vom Betreiber erstellt wurden, werden die
                Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
                Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
                Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
                entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
                werden wir derartige Inhalte umgehend entfernen.
              </p>

              <h5>Gesamtrealisation</h5>
              <p>
                <em>
                  Klinik für Psychosomatische Medizin und Psychotherapie
                  <br />
                  Sektion Systemische Gesundheitsforschung
                  <br />
                  Prof. Dr. Stefan Schmidt
                  <br />
                  Hauptstraße 8
                  <br />
                  79104 Freiburg
                  <br />
                  Telefon: +49 761 270-68805
                  <br />
                  <a href="mailto:sysdok@uniklinik-freiburg.de">
                    sysdok@uniklinik-freiburg.de
                  </a>
                </em>
              </p>

              <p>
                <em>
                  Universität Ulm
                  <br />
                  Abteilung für Klinische Psychologie und Psychotherapie
                  <br />
                  Prof. Dr. Harald Baumeister
                  <br />
                  Lise-Meitner-Str. 16
                  <br />
                  89081 Ulm
                  <br />
                  Prof. Dr. Harald Baumeister
                  <br />
                  <a href="mailto:rehacat@uni-ulm.de">rehacat@uni-ulm.de</a>
                </em>
              </p>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Impressum;
